<template>

    <section class="message-container">
      <h2 class="secondary-title">
        <font-awesome-icon :icon="['fa-regular', 'fa-circle-check']"/>
        Questionário submetido com sucesso!
      </h2>
      <!-- link to return home-->
      <p>
        <span> Regressar à </span>
        <router-link to="/home">página inicial</router-link>
        <span>.</span>
      </p>
    </section>

  </template>
  
  <script>
      export default {
          mounted() {
              localStorage.setItem('previousRoute', '/home');
          }
  };
  </script>